redirectFromCart()

document.addEventListener("DOMContentLoaded", function () {
  // Check if the URL contains the open-cart query parameter
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has("open-cart")) {
    openSideCart()
  }
})

function redirectFromCart() {
  // Check if the current page is the /cart page
  if (window.location.pathname === "/cart") {
    // Redirect to the homepage with the query string
    window.location.href = "/?open-cart=true"
  }
}

// Function to open the side cart
function openSideCart() {
  const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")

  if (cart && typeof cart.open === "function") {
    cart.open()
  }

  window.history.replaceState({}, document.title, window.location.pathname) // Remove the query string
}
